<div class="single-item layout-spacing">
    <div class="single-item__main">
        <div class="single-item__item-preview">
            @if (item()?.classification === 'video') {
                <video
                    [src]="$safeNavigationMigration(item()?.url)"
                    preload="auto"
                    autoplay
                    controls
                    muted
                    loop
                    playsinline></video>
            } @else {
                <img class="item-image" [src]="$safeNavigationMigration(item()?.url)" />
            }
        </div>
        <!-- Content Information -->
        <div class="card card--single-item">
            <h2 class="single-item__info--heading">Content Information</h2>
            <div class="item-info__wrapper">
                @for (group of contentInfo; track $index) {
                    <div class="item-info__container">
                        @for (field of group; track field.label) {
                            <div class="item-info__item">
                                <span>{{ field.label }}:</span>
                                <span>{{ resolveValue(field.key, field.type) }}</span>
                            </div>
                        }
                    </div>
                }
                @for (group of contentInfo2; track $index) {
                    <div class="item-info__container no-border">
                        @for (field of group; track field.label) {
                            <div class="item-info__item">
                                <span class="figure">{{ field.value }}</span>
                                <span class="label">{{ field.label }}</span>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    <!-- Temporary design ONLY, since they have mentioned there will be new design -->
    <div class="card card--reports">
        <div class="reports__heading">
            <h2 class="reports__heading--title">Playlist Reports</h2>
            <!-- TODO: Just import this later on since this button is reusable by nature kemerutt-->
            <ntv-button variant="accent" size="lg">Generate Report</ntv-button>
        </div>
        <!-- Reports card tabs -->
        <div class="reports__tabs">
            @for (tab of REPORTS_CARD_TABS; track $index) {
                <div
                    class="reports__tab"
                    [class.active]="currentReportTab() === tab.id"
                    (click)="setCurrentReportTab(tab.id)">
                    <svg class="reports__tab--icon" width="14" height="14">
                        <use
                            [attr.xlink:href]="
                                'assets/icons/icons-sprite.svg#' + tab.iconKey
                            "></use>
                    </svg>
                    <span class="reports__tab--label">{{ tab.label }}</span>
                </div>
            }
        </div>

        <!-- Reports table -->
        <app-table
            [columns]="getTableColumns()"
            [data]="playlistReportTabData()"
            [showColumnSettings]="false"
            [showItemCount]="false"
            tableHeight="auto" />
    </div>
</div>
